import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, size } from '@twistopayments/design-system/styles'

export const appBar = (theme: Theme) => css`
  display: grid;
  grid-template-columns: ${size[40]} auto ${size[40]};

  ${breakpoint.down('xs')} {
    background: ${theme.palette.background.accent};
    box-shadow: none;
  }
`

export const goBackButton = css`
  margin-bottom: ${size[32]};
`
